import { getID } from "src/libs/utilities"
import { ALIGN, FONT_CASE, FONT_WEIGHT } from "../interfaces"

const title = (): any[] => {
    return [
        {
            id: getID("title"),
            title: "Normal", 
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Rare", 
            typography: {
                letter_spacing: 6
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Wide",
            typography: {
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD,
                line_height:  0.9 
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Fat",
            typography: {
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  0.9 
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Harsh",
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9 
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Middle",
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9,
                font_size: 50
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Aggressive",
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9,
                font_size: 50
            },
            style: { 
                "padding": "10px 0 15px 0",  
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Large neon", 
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9,
                font_size: 100,
                text_color: "linear-gradient(0.252turn, rgba(65, 144, 255, 1) 34%, rgba(222, 55, 255, 1) 44%, rgba(255, 66, 66, 1) 57%, rgba(255, 161, 0, 1) 69%, rgba(255, 161, 0, 1) 100%)",
            },
            style: { 
                "padding": "10px 0 15px 0", 
                "color": "transparent", 
                "borderColor": "transparent",
                "borderStyle": "solid"
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Middle neon", 
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9,
                font_size: 50,
                text_color: "linear-gradient(0.252turn, rgba(65, 144, 255, 1) 34%, rgba(222, 55, 255, 1) 44%, rgba(255, 66, 66, 1) 57%, rgba(255, 161, 0, 1) 69%, rgba(255, 161, 0, 1) 100%)",
            },
            style: { 
                "padding": "10px 0 15px 0", 
                "color": "transparent", 
                "borderColor": "transparent",
                "borderStyle": "solid"
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "3D monolith", 
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  1.2,
                font_size: 35,
                text_color: "var(--force-contast-color)",
            },
            style: {  
                "padding": "10px 0 15px 0",  
                textShadow: `1px 1px 1px #957dad,
                        1px 2px 1px #957dad,
                        1px 3px 1px #957dad,
                        1px 4px 1px #957dad,
                        1px 5px 1px #957dad,
                        1px 6px 1px #957dad,
                        1px 10px 5px rgba(16, 16, 16, 0.5),
                        1px 15px 10px rgba(16, 16, 16, 0.4),
                        1px 20px 30px rgba(16, 16, 16, 0.3),
                        1px 25px 50px rgba(16, 16, 16, 0.2)`
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Volcano",
            typography: {
                font_case: FONT_CASE.NONE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  0.9,
                font_size: 50,
                text_color: "linear-gradient(to right, #553c9a 45%, #ee4b2b)"
            },
            style: { 
                "padding": "10px 0 15px 0", 
                "color": "transparent", 
                "borderColor": "transparent",
                "borderStyle": "solid"
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Stamp impressive blog", 
            align: ALIGN.START,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  1 
            },
            style: { 
                padding: '10px', 
                border: '2px solid var(--force-contast-color)',
                borderRadius: '3px',
                textDecoration: 'none',
                maxWidth: '150px',
                display: 'inline-flex',
                alignItems: 'center', 
                fontSize: '21px',
                boxSizing: 'border-box',
                textAlign: 'left',
                hyphens: "auto",
                hyphenateLimitChars: "6 3 3",
                hyphenateLimitLines: 2,   
                hyphenateLimitLast: "always",
                hyphenateLimitZone: "8%" 
            } , 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Stamp impressive paradox blog", 
            align: ALIGN.START,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  1,
                font_size: 21
            },
            style: { 
                padding: '10px',
                lineHeight: '1',
                border: '2px solid var(--force-contast-color)',
                borderRadius: '3px',
                textDecoration: 'none',
                maxWidth: '150px',
                display: 'inline-flex',
                alignItems: 'center', 
                boxSizing: 'border-box',
                textAlign: 'left',
                wordWrap: 'unset',
                lineBreak: 'anywhere'
            }, 
            beforeStyle: {},
            afterStyle: {}, 
        },
        {
            id: getID("title"),
            title: "Evening shadows", 
            align: ALIGN.MIDDLE,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.THIN,
                line_height:  1,
                font_size: 40,
                letter_spacing: 1
            },
            style: {   
                textShadow: `1px 1px 8px rgba(0, 0, 0, .08),
                    2px 2px 1px rgba(0, 0, 0, .075),
                    4px 4px 1px rgba(0, 0, 0, .07),
                    6px 6px 1px rgba(0, 0, 0, .065),
                    8px 8px 1px rgba(0, 0, 0, .06),
                    10px 10px 1px rgba(0, 0, 0, .055),
                    12px 12px 1px rgba(0, 0, 0, .05),
                    14px 14px 1px rgba(0, 0, 0, .045),
                    16px 16px 1px rgba(0, 0, 0, .04),
                    18px 18px 1px rgba(0, 0, 0, .035),
                    20px 20px 1px rgba(0, 0, 0, .03),
                    22px 22px 1px rgba(0, 0, 0, .025),
                    24px 24px 1px rgba(0, 0, 0, .02),
                    26px 26px 1px rgba(0, 0, 0, .015),
                    28px 28px 1px rgba(0, 0, 0, .01),
                    30px 30px 1px rgba(0, 0, 0, .005),
                    32px 32px 1px rgba(0, 0, 0, .0025),
                    34px 34px 1px rgba(0, 0, 0, .002),
                    36px 36px 1px rgba(0, 0, 0, .0015),
                    38px 38px 1px rgba(0, 0, 0, .001)`
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Egyptian megalith", 
            align: ALIGN.MIDDLE,
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.NORMAL,
                line_height:  1.2,
                font_size: 40,
                text_color: "#999",  
            },
            style: {
                padding: 5, 
                textShadow: '1px 1px 0 #000, -1px -1px 0 #fff',
            },
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Dangerous stanchion", 
            align: ALIGN.START,
            style: {
                marginLeft: 10,
            },
            afterStyle: {  
                position: 'absolute',
                height: '22px',
                width: '5px',
                background: 'var(--red)',
                top: '21%',
                left: 0
            } 
        },
        {
            id: getID("title"),
            title: "Dangerous base", 
            align: ALIGN.START,
            typography: { 
                font_size: 18 
            },
            "style": { "marginLeft": 0, },
            "afterStyle": {
                "position": "absolute",
                "height": 5,
                "width": 100,
                "background": "var(--red)",
                "bottom": 0,
                "left": 0
            }
        },
        {
            id: getID("title"),
            title: "Dangerous sky clad", 
            align: ALIGN.START,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  1.2,
                font_size: 18,
                text_color: 'var(--red)'
            },
            "style": { "marginLeft": 0, margin: "20px 0", maxWidth: 300 },
            "beforeStyle": { 
                position: 'absolute',
                top: -22,
                left: 0,
                width: 250,
                height: 20,
                backgroundColor: 'var(--red)'
            },
            "afterStyle": { 
                position: 'absolute',
                bottom: -16,
                left: 0,
                width: 250,
                height: 20,
                backgroundColor: 'var(--red)'
            },
        },
        {
            id: getID("title"),
            title: "Beauty of words", 
            align: ALIGN.START,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD,
                line_height:  1.2,
                font_size: 18,
                text_color: "#f2f2f2"
            },
            "spanStyle":  { 
                background: "var(--red)", 
                float: "left",
                padding: "2px 10px", 
            },
            "beforeStyle": { },
            "afterStyle": { },
        },
        {
            id: getID("title"),
            title: "Pony pontes", 
            align: ALIGN.START,
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK, 
                font_size: 50,
                text_color: `linear-gradient(45deg, 
var(--red) 12.5%, 
rgba(232, 227, 199, 0) 12.5%, 
rgba(232, 227, 199, 0) 37.5%, 
var(--red) 37.5%, 
var(--red) 62.5%, 
rgba(232, 227, 199, 0) 62.5%, 
rgba(232, 227, 199, 0) 87.5%, 
var(--red) 87.5%)`,
            },
            
            style: { 
                backgroundSize: "4px 4px",
                backgroundPosition: "0 0"
            },
            "spanStyle":  { },
            "beforeStyle": { },
            "afterStyle": { },
        },
        {
            id: getID("title"),
            title: "Stump", 
            align: ALIGN.MIDDLE,
            typography: {
                font_case: FONT_CASE.UPPERCASE,
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD,
                line_height:  1,
                font_size: 21,
                text_color: "#f2f2f2"
            },
            "style": { 
                "padding": "10px", 
                "border": "2px solid var(--force-contast-color)",
                "borderRadius": "3px",
                "textDecoration": "none",
                "width": "150px",
                "display": "inline-flex",
                "alignItems": "center",
                "textTransform": "uppercase", 
                "boxSizing": "border-box",
                "textAlign": "center",
                justifyContent: "center"
            },
            "beforeStyle": {
                "background": "var(--force-contast-color)",
                "height": 2,
                "margin": "0 1em",
                "flex": 1,
                "position": "absolute", 
                "width": 100,
                "top": "50%",
                "left": "calc(50% - 195px)"
            },
            "afterStyle": {
                "background": "var(--force-contast-color)",
                "height": 2,
                "margin": "0 1em",
                "flex": 1,
                "position": "absolute", 
                "width": 100,
                "top": "50%" ,
                "left": "calc(50% + 52px)"
            }
        },
        {
            id: getID("title"),
            title: "Hallo, everybody", 
            align: ALIGN.MIDDLE,
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD, 
            },
           "style": {
                "fontSize": "1.5em", 
                "display": "flex"
            },
            "spanStyle": {},
            "beforeStyle": {
                "content": "[",
                "paddingRight": "5px",
                "left": "auto",
                "position": "relative",
                "top": "auto",      
                "color": "#16a085"
            },
            "afterStyle": {
                "content": "]",
                "paddingLeft": "5px",
                "right": "auto",
                "position": "relative",
                "top": "auto",      
                "color": "#16a085"
            }
        },
        {
            id: getID("title"),
            title: "Glitch title", 
            align: ALIGN.MIDDLE,
            typography: { 
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD, 
            },
           style: {
                fontSize: 46, 
                fontWeight: 900,
                textTransform: "uppercase",
                letterSpacing: "0.01em",
                transform: "scale3d(1,1,1)"
            },
            spanStyle: {},
            beforeStyle: {
                content:"attr(data-text)",
                position: "absolute",
                top: 0, 
                left: -1,
                width: "100%",
                overflow: "hidden",
                textShadow: "4px 0 rgba(red,0.7)",
                animation: "glitch-loop-1 0.8s infinite ease-in-out alternate-reverse"
            },
            afterStyle: {
                content:"attr(data-text)",
                position: "absolute",
                top: 0,
                left: 1,
                width: "100%",
                overflow: "hidden",
                textShadow: "-5px 0 rgba(blue,0.7)",
                animation: "glitch-loop-2 0.8s infinite ease-in-out alternate-reverse"
            }, 
        },
        {
            id: getID("title"),
            title: "Disco alliance", 
            align: ALIGN.MIDDLE,
            typography: { 
                font: "var(--fontFamily)",
                font_case: FONT_CASE.UPPERCASE,
                font_weight: FONT_WEIGHT.EXTRA_BOLD,  
                text_color: `#FFFFFF`,
            },
           style: {
                fontSize: 50,   
                letterSpacing: "0.03em",
                position: "relative",    
                transform: "skew(-15deg)",
                "-webkit-text-stroke": "2px #ffffff59",
            },
            spanStyle: {
                
            },
            beforeStyle: {
                content:"attr(data-text)",
                position: "absolute",
                top: 0,
                left: 0, 
                width: "100%",
                display: "block",
                textShadow: "0 0 0.1em #8ba2d000, 0 0 0.2em black, 0 0 5em #165ff300",
                "-webkit-text-stroke": "0.1em #00000059"
            },
            __beforeStyle: {
                content: '',
                position: "absolute",
                top: "-0.03em",
                left: "0.0125em",
                width: ".4em",
                height: "0.4em",
                transform: "skew(-15deg)",
                background: "radial-gradient(white 3%, rgba(white, 0.3) 15%, rgba(white, 0.05) 60%, transparent 80%), radial-gradient(rgba(white, 0.2) 50%, transparent 60%) 50% 50% / 5% 100%, radial-gradient(rgba(white, 0.2) 50%, transparent 60%) 50% 50% / 70% 5%",
                backgroundRepeat: "no-repeat",
                zIndex: 3,
            },
            afterStyle: {
                content:"attr(data-text)",
                position: "absolute",
                top: 0,
                left: 0, 
                width: "100%",
                display: "block",
                color: "transparent",
                backgroundImage: "linear-gradient(#032d50 25%, #00a1ef 35%, white 50%, #20125f 50%, #8313e7 55%, #ff61af 75%)",
                backgroundClip: "text",
                willChange: "transform",
                backgroundPosition: "center center !important",
                zIndex: 1,
            }, 
        },
    ]
}
export default title